import React, { useEffect, useState } from 'react';
import { dateFormate } from '../../../utils/helper';
import { LeadFormActions } from '../../../Services/_actions';
import { userInfoByNumberAtom } from '../../../Services/_states';
import { useRecoilValue } from 'recoil';
import LongStringView from '../../Shared/LongStringView/index.tsx';
import CommonTable from '../../Shared/Tables/TableV1.tsx';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { Grid, Box, Typography, CircularProgress } from '@mui/material';

const KnowlarityModal = ({ listItems = [] }) => {
  const leadFormActions = LeadFormActions();
  const userDetailByNumber = useRecoilValue(userInfoByNumberAtom);
  const [filterObj, setFilterObj] = useState({ destination: userDetailByNumber?.phone_number });
  const [recordingList, setRecordingList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCustomerRecordings = async (obj) => {
    setLoading(true);
    let res = await leadFormActions.getCustomerRecordings(obj);
    setLoading(false);
    if (res?.status === 200) {
      setRecordingList(res?.data);
    }
  };

  const onSelectDisposition = (selectedOption) => {
    setFilterObj({ ...filterObj, disposition: selectedOption?.value || null });
    getCustomerRecordings({ ...filterObj, disposition: selectedOption?.value || null });
  };

  const handleSearchDisposition = (searchText) => {
    // Handle search here, like filtering options based on the searchText
    console.log('Search Text:', searchText);
  };

  useEffect(() => {
    getCustomerRecordings(filterObj);
  }, []);

  const columns = [
    {
      accessorKey: 'sent_count', // Use 'accessorKey' instead of 'dataField'
      header: 'Audio',
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <audio controls style={{ maxWidth: '100%' }}>
                <source src={row?.getValue('resource_url') || ''} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </div>
            <div>{dateFormate(row?.getValue('start_time'), 'DD-MM-YYYY hh:mm:ss A')}</div>
          </>
        );
      },
    },
    {
      accessorKey: 'disposition',
      header: 'Status',
      enableSorting: false,
      muiTableHeadCellProps: {
        align: 'center',
      },
    },
    {
      accessorKey: 'comment',
      header: 'Comment',
      enableSorting: false,
      muiTableHeadCellProps: {
        align: 'center',
      },
      Cell: ({ row }) => {
        return <LongStringView longString={row?.getValue('comment') ?? ''} />;
      },
    },
  ];

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography variant="h6">Call Recordings</Typography>
        <Box sx={{ minWidth: 250, maxWidth: 350, width: '35%' }}>
          <SearchableDropdown
            options={leadFormActions.despositionStatusArr}
            label="Select Disposition"
            value={
              filterObj?.disposition
                ? { label: filterObj?.disposition, value: filterObj?.disposition }
                : null
            }
            onChange={onSelectDisposition}
            loading={loading}
            onSearch={handleSearchDisposition}
            sx={{ width: '100%' }}
          />
        </Box>
      </Box>

      <Box sx={{ height: '400px', overflow: 'auto' }}>
        <CommonTable
          columns={columns}
          data={recordingList || []}
          enablePagination={false}
          enableRowSelection={false}
          enableTopToolbar={false}
          enableBottomToolbar={false}
        />
      </Box>
    </Box>
  );
};

export default KnowlarityModal;
